import React, { Component } from 'react';
import Footer from "../../components/Footer";
import Nav from '../../components/Nav/index';
import {withRouter} from "react-router-dom";
import './index.less';
import anime from 'animejs';
import { message } from "antd";
import Loader from '../../components/loader';
import Utils from '../../utils/utils';
import newsBottom from '../../assets/img/news_bottom.png';
import Axios from "../../axios";
import Fade from 'react-reveal/Fade';
import $ from 'jquery';
const rdom = require('react-dom');
class News extends Component {
    state = {
        n_day: '',
        n_month: '',
        n_year: '',
        newsPic: newsBottom,
        isLoading: true,
        isOpacity: 1
    }
    componentWillMount() {
        this.newsRequest();//获取新闻
        this.newsListRequest();//新闻列表
        let time = new Date();
        let dateArray = Utils.getNowTime(time);//获取
        // console.log(dateArray)
        let n_day = dateArray[0],
            n_month = dateArray[1],
            n_year = dateArray[2],
            m_year = dateArray[1] + ' ' + dateArray[2];
        this.setState({
            n_day,
            n_month,
            n_year,
            m_year
        })
    }
    //高亮
    handleMouse = (e, id) => {
        // console.log(id)
        let target = e.target;
        const { newsList } = this.state;
        newsList.map((item, i) => {
            // console.log(item)
            if (item.id === id) {
                item.isActive = true;
                console.log(item)
                // console.log(JSON.parse(item.content))
                let content = JSON.parse(item.content);
                // console.log(content)
                this.setState({
                    newsPic: content[0].img
                })
            } else {
                item.isActive = false;
                // proItems[0].isActive=true;
            }
        })
    }
    /*列表数据请求*/
    newsRequest = () => {
        let _this = this;
        var params = { key: "NewsHome" };
        this.setState({
            isLoading: true,
        })
        Axios.get({
            block: '/api/option',
            url: '/queryOption',
            params: params,
        }).then((data) => {
            if (data.code === 0) {
                let items = data.data;
                console.log(items)
                console.log(JSON.parse(items))
                let item = JSON.parse(items);
                this.setState({
                    describe: item.describe,
                    themeImg: item.themeImg
                })
            } else {
                message.error(data.msg)
            }
            setTimeout(function () {
                _this.setState({
                    isLoading: false
                })
            },1000)
            // this.animation();
        }).catch((error) => {
            console.log(error);
        })
    };
    /*列表数据请求*/
    newsListRequest = () => {
        let _this = this;
        var params = { type: "NewsList", includeContent: true };
        this.setState({
            isLoading: true,
        })
        Axios.post({
            block: '/api',
            url: '/post',
            params: params,
        }).then((data) => {
            console.log(data)
            if (data.code === 0) {
                let newsList = [];
                let items = data.data;
                // console.log(items)
                for (let i in items) {
                    let item = items[i].post;
                    // let _time = new Date(item.time);
                    // let dateArray = Utils.getNowTime(_time);//获取
                    // let time = dateArray[0] + ' ' + dateArray[1] + dateArray[2];
                    // // console.log(time)
                    // item.time = time;

                    let time1 = item.time.substring(0,11).split('-').join('/');
                    let _time = new Date(time1);
                    let dateArray = Utils.getNowTime(_time);//获取
                    let time = dateArray[0] + ' ' + dateArray[1] + dateArray[2];
                    item.time = time;
                    item.isActive = false;
                    if (i == 0) {
                        item.isActive = true;
                    }
                    newsList.push(item);
                }
                console.log(newsList)
                sessionStorage.setItem('newsList', JSON.stringify(newsList));
                this.setState({
                    newsList
                })
            } else {
                message.error(data.msg)
            }
            /*this.setState({
                isLoading: false
            })*/
            setTimeout(function () {
                _this.setState({
                    isLoading: false
                })
            },1000)
            // this.animation();
        }).catch((error) => {
            console.log(error);
        })
    };

    scrollFunc= (e) =>{
        e = e || window.event;
        var isEn = this.state.isOpacity;
        var c_Text = document.getElementsByClassName("cn-title")[0];
        if (e.wheelDelta) { //第一步：先判断浏览器IE，谷歌滑轮事件
         if (e.wheelDelta > 0) { //当滑轮向上滚动时
        //   console.log("滑轮向上滚动");
          if (isEn === 0) {
            this.setState({
                isOpacity: 1
            })
              c_Text.innerText = '新闻/态度'
            anime.timeline({ loop: 1 })
                .add({
                    targets: '.cn-title',
                    translateY: ['3em', 0],
                    opacity: [0, 1],
                    easing: "easeInExpo",
                    duration: 300
                })
        }
         }
         if (e.wheelDelta < 0) { //当滑轮向下滚动时
          if (isEn === 1) {
            this.setState({
                isOpacity: 0
            })
              c_Text.innerText = 'News/Attitude'
            anime.timeline({ loop: 1 })
                .add({
                    targets: '.cn-title',
                    translateY: ['3em', 0],
                    opacity: [0, 1],
                    easing: "easeInExpo",
                    duration: 300
                })
        }
         }
        } else if (e.detail) { //Firefox滑轮事件
         if (e.detail> 0) { //当滑轮向上滚动时
          if (isEn === 0) {
            this.setState({
                isOpacity: 1
            })
              c_Text.innerText = '新闻/态度'
            anime.timeline({ loop: 1 })
                .add({
                    targets: '.cn-title',
                    translateY: ['3em', 0],
                    opacity: [0, 1],
                    easing: "easeInExpo",
                    duration: 300
                })
        }
         }
         if (e.detail< 0) { //当滑轮向下滚动时
        //   console.log("滑轮向下滚动");
          if (isEn === 1) {
            this.setState({
                isOpacity: 0
            })
              c_Text.innerText = 'News/Attitude'
            anime.timeline({ loop: 1 })
                // .add({
                //     targets: '.cn-title',
                //     translateY: [0, '-3em'],
                //     opacity: [1, 0],
                //     easing: "easeOutExpo",
                //     duration: 300
                // })
                .add({
                    targets: '.cn-title',
                    translateY: ['3em', 0],
                    opacity: [0, 1],
                    easing: "easeInExpo",
                    duration: 300
                })
           }
         }
        }
       }
    componentDidMount() {
      /*  if (document.addEventListener) {
            document.addEventListener('DOMMouseScroll', this.scrollFunc.bind(this), false);
        }
        window.onmousewheel = document.onmousewheel = this.scrollFunc.bind(this);*/
    }
    render() {
        const { n_year, n_month, n_day, describe, themeImg, newsList, newsPic, isLoading, m_year } = this.state;
        console.log(newsPic)
        return (
            <div>
                {
                    isLoading ? <Loader cTitle="新闻" eTitle="NEWS" />
                        : <div className="news" >
                            <header className="header-title">
                                <h1 className="white">
                                    <a href="/news">news</a>
                                </h1>
                            </header>
                            <div className="detail-info">
                                <div className="info-exp">
                                    <div className="left date-box">
                                        <h4 className="d-title">
                                            <Fade cascade duration={3000}>
                                                {n_day}
                                            </Fade>
                                        </h4>
                                        <h4 className="y-title">
                                            <Fade cascade duration={3000}>
                                                {m_year}
                                            </Fade>
                                        </h4>
                                    </div>
                                    <div className="right">
                                        <h5 className="news-info">
                                            <Fade bottom delay={1000}>
                                                {describe}
                                            </Fade>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                         {/*   <div className="main-image1">
                                <div className="info">
                                    <div className="left">
                                        <img src={Utils.getUrl(themeImg)} alt="news" />
                                        <h4 className="cn-title">新闻/态度</h4>
                                        <h4 className="en-title" style={{ opacity: 0 }}>News/Attitude</h4>
                                    </div>
                                    <div className="right">

                                        <h4>
                                            <span className="cn-title">新闻/态度</span>
                                            <span className="en-title"
                                                  style={{opacity: isOpacity, marginLeft: '-13rem'}}>News/Attitude</span>
                                        </h4>
                                    </div>

                                </div>
                            </div>*/}
                            <div className="detail-switch">
                                <div className="switch-info">
                                    <div id="handler">
                                        <div className="hot-news">
                                            <h2>热点新闻</h2>
                                            <p>聚焦智能家居</p>
                                        </div>
                                        <div className='projects-wrapper-ul'>
                                            <ul className="projects-wrapper">
                                                {
                                                    newsList && newsList.map((item, index) => {
                                                        return (
                                                            <li className="project" key={index}>
                                                                {
                                                                    item.isActive ?
                                                                        <a onClick={()=>{this.props.history.push( `/newsDetail/${item.id}`)}}
                                                                           value={item.id}
                                                                            onMouseOver={(e) => this.handleMouse(e, item.id)}>
                                                                            <h4 style={{ color: '#1678C1' }}>{item.title}</h4>
                                                                            <p style={{ color: '#1678C1' }}>{item.time}</p>
                                                                        </a>
                                                                        :
                                                                        <a onClick={()=>{this.props.history.push( `/newsDetail/${item.id}`)}}
                                                                           value={item.id}
                                                                            onMouseOver={(e) => this.handleMouse(e, item.id)}>
                                                                            <h4>{item.title}</h4>
                                                                            <p>{item.time}</p>
                                                                        </a>
                                                                }
                                                            </li>

                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="hot-pic">
                                        {
                                            newsPic?
                                                <img src={Utils.getUrl(newsPic)} alt="" />
                                                :''
                                        }
                                    </div>
                                </div>
                                <Footer />
                            </div>
                        </div>
                }
                 {/*<Nav/>*/}
            </div>

        )
    }
}
export default withRouter(News);
